import { gql } from '@apollo/client';

export const HIDE_POST_FROM_FEED = gql`
    mutation hidePostFromFeed($postId: ID!) {
        hidePostFromFeed(postId: $postId)
    }
`;
